import Transactions from "../Components/Transactions";

export default function Index() {
  return (
    <div>
      <Transactions />
    </div>
  );
}
